import { useState } from "react";
import { toast } from "sonner";
import { Check, ShieldCheck, Sparkles } from "lucide-react";
import { api, apiError } from "@/lib/api";

export const PLAN_FEATURES = [
  "15 blogueurs et 5 mots-clés surveillés",
  "Veille quotidienne réelle Facebook & TikTok",
  "Tous les buzz du jour (jusqu'à 3 par source) + commentaires viraux",
  "30 vidéos par mois : montages, voix off, résumé du jour",
  "Toutes les langues, toutes les niches",
];

export function Paywall() {
  const [busy, setBusy] = useState(false);
  const start = async () => {
    setBusy(true);
    try {
      const { checkout_url } = await api.checkout();
      window.location.href = checkout_url;
    } catch (e) {
      toast.error(apiError(e));
      setBusy(false);
    }
  };
  return (
    <div className="max-w-xl mx-auto my-12 card-surface p-8 fade-up" data-testid="paywall">
      <span className="chip chip-fb"><Sparkles className="w-3 h-3" /> 7 jours offerts</span>
      <h1 className="font-display text-3xl font-extrabold mt-4">Activez votre agent BuzzlyMe</h1>
      <p className="text-[#65676b] mt-2">Essai gratuit de 7 jours, puis 19,99 €/mois. Sans engagement, annulable à tout moment.</p>
      <ul className="mt-6 space-y-2.5">
        {PLAN_FEATURES.map(f => (
          <li key={f} className="flex items-start gap-2 text-sm"><Check className="w-4 h-4 text-[#1877f2] mt-0.5 shrink-0" /> {f}</li>
        ))}
      </ul>
      <button type="button" onClick={start} disabled={busy} className="btn-primary w-full justify-center mt-8 !py-3" data-testid="start-trial-btn">
        {busy ? "Redirection vers le paiement…" : "Démarrer mon essai gratuit"}
      </button>
      <p className="mt-3 text-xs text-[#8a8d91] flex items-center gap-1.5"><ShieldCheck className="w-3.5 h-3.5" /> Paiement sécurisé par Stripe. Aucun débit avant la fin de l'essai.</p>
    </div>
  );
}
